/**
 * Normalizes a hub data-source env value to `ers` or `payload`.
 * Strips inline comments (e.g. `payload # staging`).
 *
 * @param {string | undefined} raw
 * @param {'ers' | 'payload'} [fallback='ers']
 * @returns {'ers' | 'payload'}
 */
export function parseHubSource(raw, fallback = "ers") {
  const value = (raw ?? fallback).split("#")[0].trim().toLowerCase();
  return value === "payload" ? "payload" : "ers";
}
